import { Component, Output, Input, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { HeaderGroup } from '../../header-group';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { GrpLabelCtrl, GrpNameCtrl } from '@documalis/_const/const';

@Component({
    selector: 'app-form-group',
    templateUrl: './form-group.component.html',
    styleUrls: ['./form-group.component.scss'],
    providers: [AutofocusDirective],
})
export class FormGroupComponent extends FormBase implements OnInit, OnDestroy {
    public resultForm: FormGroup;
    public validClick = false;
    public isAdmin = false;

    @Input()
    public dataItem: HeaderGroup = null;

    @Input()
    public userListBase: any;

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    
    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.resultForm = this.formBuilder.group({
            grpname: [null, [Validators.required, Validators.pattern(GrpNameCtrl), Validators.minLength(1), Validators.maxLength(40)]],
            desc: '',
            gr_label: ['', Validators.pattern(GrpLabelCtrl)],
            external: '',
            autogenerated: false,
            userList: '',
        });
        this.initialization();
    }

    ngOnInit() {
        if (this.dataItem !== null) {    
            this.dataItem.notifyParent.subscribe(success => {
                if (this.dataItem.duplicate === true) {
                    this.resultForm.controls['grpname'].enable();
                } else {
                    this.resultForm.controls['grpname'].disable();
                }
                this.resultForm.patchValue(this.dataItem);
            })
        }
    }

    ngOnDestroy() {
        if (this.dataItem !== null) {            
            this.dataItem.notifyParent.unsubscribe()
        }
    }

    public validate() {
        let wRequest: any;
        wRequest = new Object();
        wRequest = {
            data: this.resultForm.value,
        };
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            if (this.dataItem) {
                if (this.ctrlDuplicate() === false) {
                    return;
                }
                wRequest = this.setValues(wRequest);
            } else {
                wRequest.data.autogenerated = false;
                wRequest.data.grpname = this.resultForm.controls.grpname.value.trim();
            }    
            this.onValidate.emit(wRequest);
        }
    }

    private setValues(aRequest) {
        if (this.dataItem.duplicate === true) {
            aRequest.data.grpname = this.resultForm.controls.grpname.value.trim();
            aRequest.data.autogenerated = false;
        } else {
            aRequest.data.grpname = this.dataItem.grpname.trim();
            aRequest.data.autogenerated = this.dataItem.autogenerated;
        }
        return aRequest;
    }

    private ctrlDuplicate() {
        if (this.dataItem.duplicate === false) {
            return true;
        }
        if (this.dataItem.grpname === this.resultForm.controls.grpname.value) {
            this._messageService.addWarn(this.translate.instant('Cf_GrpEqual'));
            return false;
        } else {
            return true;
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.resultForm.value);
    }

    private initialization() {
        this.keys = {
            grpname: {
                label: this.translate.instant('Cf_GrpName'),
                pattern: '',
            },
            gr_label: {
                label: this.translate.instant('Label'),
                pattern: '',
            },
        };
    }
}
